<template>
  <div class="group" :class="{expanded}" @click="emit('toggle')">
    <BaseIcon size="18" :name="expanded?'expand_less':'expand_more'" />
    <div class="group-name">{{ name }}</div>
  </div>
  <slot v-if="expanded" />
</template>
<script lang="ts" setup>
  import BaseIcon from '@/components/BaseIcon.vue'

  defineProps<{ expanded: boolean; name: string }>()
  const emit = defineEmits<{ toggle: [] }>()
</script>
